import Variations from '../../../../components/variations/variations.desktop';
import variations from './variations';

export default variations(Variations);
